module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-vodafonerebranding-intro-card1.1@2x.d36152f7.jpg";